import firebase, {User} from 'firebase/app';
import UserCredential = firebase.auth.UserCredential;

export class AuthApi {
  public async registerApi(displayName: string, email: string, password: string) {
    const userCredential: UserCredential = await firebase.auth().createUserWithEmailAndPassword(email, password);
    await this.updateDisplayName(userCredential.user!, displayName)
  }

  public async updateDisplayName(user: User, displayName: string) {
    await user.updateProfile({
      displayName: displayName
    });
  }

  public async loginApi(email: string, password: string) {
    await firebase.auth().signInWithEmailAndPassword(email, password);
  };

  public async logoutApi(): Promise<void> {
    await firebase.auth().signOut();
  };

  public getCurrentUser(): User | null {
    return firebase.auth().currentUser;
  }
}


